<script>
export default {
    props: {
        id: {
            type: String,
            required: true
        },
        class: {
            type: String
        },
        placeholder: {
            type: String,
        },
        value: {
            type: String
        },
        disabled: {
            type: Boolean,
            default: false
        },
        boundsNorth: {
            type: Number
        },
        boundsEast: {
            type: Number
        },
        boundsSouth: {
            type: Number
        },
        boundsWest: {
            type: Number
        },
    },
    data() {
        return {
            selectedAddress: {
                placeId: '',
                displayName: '',
                country: '',
                district: '',
                postcode: '',
                city: '',
                street: '',
                houseNr: '',
                poi: false,
                latitude: 0,
                longitude: 0
            }
        }
    },
    emits: [
        'address-changed'
    ],
    methods: {

        initAutocomplete() {

            const that = this;

            let autoCompleteInput = this.$refs.addressInput;
            if (!autoCompleteInput) {
                return;
            }

            that.selectFirstOnEnter(autoCompleteInput);

            const bounds = {
                north: that.boundsNorth,
                east: that.boundsEast,
                south: that.boundsSouth,
                west: that.boundsWest
            };

            // Init autocomplete, set default properties
            const ac = new google.maps.places.Autocomplete(autoCompleteInput, {
                bounds: bounds,
                strictBounds: true,
                componentRestrictions: {
                    country: 'hu'
                }
            });

            // Change event, fired when the user selects an address from the dropdown
            autoCompleteInput.addEventListener('input', function () {
                that.addressChanged(false);
            });

            autoCompleteInput.addEventListener('keydown', function (e) {
                if (e.code == 13) {
                    e.preventDefault();
                    // TODO Focus to submit button!
                    return false;
                }
            });

            ac.addListener('place_changed', function () {

                const place = ac.getPlace();

                if (!place || !place.geometry) {
                    that.addressChanged(false);
                    return;
                }

                that.selectedAddress.placeId = place.place_id;
                that.selectedAddress.displayName = (place.types.includes('locality') || place.types.includes('point_of_interest')) ? place.name : place.formatted_address;
                for (let i = 0; i < place.address_components.length; i++) {
                    switch (place.address_components[i].types[0]) {
                        case 'country':
                            that.selectedAddress.country = place.address_components[i].long_name;
                            break;
                        case 'sublocality_level_1':
                            that.selectedAddress.district = place.address_components[i].long_name;
                            break;
                        case 'postal_code':
                            that.selectedAddress.postcode = place.address_components[i].long_name;
                            break;
                        case 'locality':
                            that.selectedAddress.city = place.address_components[i].long_name;
                            break;
                        case 'route':
                        case 'neighborhood':
                            that.selectedAddress.street = place.address_components[i].long_name;
                            break;
                        case 'street_number':
                            that.selectedAddress.houseNr = place.address_components[i].long_name;
                            break;
                    }
                }
                that.selectedAddress.poi = place.types.includes('point_of_interest');
                that.selectedAddress.latitude = place.geometry.location.lat();
                that.selectedAddress.longitude = place.geometry.location.lng();

                that.addressChanged(true);
            });

            return ac;

        },

        selectFirstOnEnter(input) {

            const _addEventListener = (input.addEventListener) ? input.addEventListener : input.attachEvent;

            function addEventListenerWrapper(type, listener) {
                if (type == 'keydown') {
                    let originalListener = listener;
                    listener = function (event) {
                        if (!document) {
                            return;
                        }
                        const suggestionSelected = document.getElementsByClassName('pac-item-selected').length > 0;
                        if (event.which == 13 && !suggestionSelected) {
                            const simulatedDownArrow = new KeyboardEvent('keydown', { keyCode: 40 });
                            originalListener.apply(input, [simulatedDownArrow]);
                        }
                        originalListener.apply(input, [event]);
                    };
                }
                _addEventListener.apply(input, [type, listener]);
            }

            if (input.addEventListener) {
                input.addEventListener = addEventListenerWrapper;
            } else if (input.attachEvent) {
                input.attachEvent = addEventListenerWrapper;
            }

        },

        addressChanged(isSelected) {

            if (!isSelected) {
                this.selectedAddress.placeId = '';
                this.selectedAddress.displayName = '';
                this.selectedAddress.country = '';
                this.selectedAddress.district = '';
                this.selectedAddress.postcode = '';
                this.selectedAddress.city = '';
                this.selectedAddress.street = '';
                this.selectedAddress.houseNr = '';
                this.selectedAddress.poi = false;
                this.selectedAddress.latitude = 0;
                this.selectedAddress.longitude = 0;
            } else {
                // this.$emit('update:modelValue', this.$refs.addressInput.value);
            }

            this.$emit('address-changed', this.selectedAddress, this.$refs.addressInput.value);

        }

    },
    mounted() {
        this.initAutocomplete();
        this.addressChanged(false);
    }
}
</script>

<template>
    <input type="text" :id="id" :name="id + '-google-autocomplete'" :class="class" :placeholder="placeholder" :disabled="disabled" :value="value" maxlength="255" autocomplete="off"
        ref="addressInput">
    <label :for="id">{{ placeholder }}</label>
</template>
